import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateResearcherCertificateDialogComponent } from '../create-researcher-certificates-dialog/create-researcher-certificate-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { switchMap, tap } from 'rxjs/operators';
import { EMPTY, Observable, of } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from "@angular/material/sort";
import { CompaniesService } from "../../../services/companies.service";
import { ResearcherCertificate } from "../../../model/researcher-certificate";
import { DialogsService } from "../../../services/dialogs.service";
import { SnackService } from "../../../services/snack.service";
import { GeneralItemDetailDialogComponent } from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import { Router } from "@angular/router";
import { Constants } from "../../../utils/constants";
import { ResearchersCertificatesService } from "../../../services/researchers-certificates.service";
import { BoxCertificate } from "../../../model/box-certificate";
import { merge } from "lodash-es";


@Component({
  selector: 'aw-list-researcher-certificates',
  templateUrl: './list-researcher-certificates.component.html',
  styleUrls: ['./list-researcher-certificates.component.scss']
})
export class ListResearcherCertificatesComponent implements OnInit, AfterViewInit {

  public displayedColumns = [

    'creationDate',
    'endDate',
    'revokeDate',
    'researcher',
    'cmId',
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  @ViewChild('paginatorResearcherCertificates') paginatorUsers!: MatPaginator;
  dataSource!: MatTableDataSource<ResearcherCertificate>;
  private allResearcherCertificates$!: Observable<ResearcherCertificate[]>;
  expandedCertificateElement?: ResearcherCertificate;
  roles = Constants.roles;
  entities = Constants.entities;
  certificatesStatuses = Constants.certificateStatuses;

  constructor(
    public dialog: MatDialog,
    private companiesService: CompaniesService,
    private researcherCertificatesService: ResearchersCertificatesService,
    private dialogsService: DialogsService,
    private snackService: SnackService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.allResearcherCertificates$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => this.researcherCertificatesService.getAllResearcherCertificates()),
          tap(x => {
            this.dataSource = new MatTableDataSource<ResearcherCertificate>(x);
            this.dataSource.paginator = this.paginatorUsers;
            this.loading = false;
          })
        );
    this.allResearcherCertificates$.subscribe();
  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortResearcherCertificates(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {

      const index: string = event.active;

      if (event.active === 'researcher') {
        if (event.direction === 'asc') {
          return ('' + b.researcher?.firstName).localeCompare('' + a.researcher?.firstName);
        } else {
          return ('' + a.researcher?.firstName).localeCompare('' + b.researcher?.firstName);
        }
      }

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }

    });
  }

  details(certificate: ResearcherCertificate): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: certificate });
  }

  createResearcherCertificate(): void {
    this.disabled = true;
    this.dialog
      .open(CreateResearcherCertificateDialogComponent, { data: new ResearcherCertificate() })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allResearcherCertificates$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editResearcherCertificate(certificate: ResearcherCertificate): void {
    this.disabled = false;
    this.dialog
      .open(CreateResearcherCertificateDialogComponent, { data: certificate })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allResearcherCertificates$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        },
        () => {
          this.disabled = false;
        });
  }

  deleteResearcherCertificate(researcherCertificate: ResearcherCertificate): void {
    this.disabled = true;
    const id = researcherCertificate.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Delete researcher certificate', `Are you sure you want to delete the researcher certificate "${researcherCertificate.cmId}"?`)
      .pipe(
        switchMap((value) => value ?
          this.researcherCertificatesService.deleteResearcherCertificate(<number>researcherCertificate.id) :
          EMPTY),
        switchMap(() => this.allResearcherCertificates$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Researcher certificate deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }

  revokeResearcherCertificate(researcherCertificate: ResearcherCertificate): void {
    this.disabled = true;
    const editedBoxCertificate = merge(new BoxCertificate(), researcherCertificate);
    editedBoxCertificate.status = this.certificatesStatuses.revoked;
    this.dialogsService
      .confirm('Revoke certificate', `Are you sure you want to revoke the researcher certificate "${researcherCertificate.cmId}"?`)
      .pipe(
        switchMap((value) => value ?
          this.researcherCertificatesService.updateResearcherCertificate(editedBoxCertificate) :
          EMPTY),
        switchMap(() => this.allResearcherCertificates$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Researcher certificate revoked!');
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
      },
        () => {
          this.disabled = false;
        });

  }

}
